<template>
  <main>
    <div class="path">
      <i class="el-icon-caret-right"></i>账号中心
      <i class="el-icon-arrow-right"></i>&nbsp;账号安全
    </div>

    <section class="content_wrapper">
      <div class="my-table">
        <div>
          <div class="table-row">
            <span class="table-cell" style="width: 120px; font-weight: bold;">账号ID</span>
            <span class="table-cell" style="width: 780px; color: #666;">登录系统时需要输入的账号</span>
            <span class="table-cell" style="width: 250px;">{{customer.username}}</span>
            <span class="table-cell" style="width: 70px;">
            </span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">

          <div class="table-row">
            <span class="table-cell" style="width: 120px; font-weight: bold;">登录密码</span>
            <span class="table-cell" style="width: 780px; color: #666;">登录系统时需要输入的密码</span>
            <span class="table-cell" style="width: 250px;">已设置</span>
            <span class="table-cell" style="width: 70px;">
              <el-link icon="el-icon-edit" type="primary" :underline="false" @click="openUpdateDialog(1)">修改&nbsp</el-link>
            </span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">

          <div class="table-row">
            <span class="table-cell" style="width: 120px; font-weight: bold;">安全手机号</span>
            <span class="table-cell" style="width: 780px; color: #666;">用于手机验证码登录、接收消息、验证身份（如找回密码、变更安全设置等）</span>
            <span class="table-cell" style="width: 250px;">{{customer.loginPhone}}</span>
            <span class="table-cell" style="width: 70px;">
              <el-link icon="el-icon-edit" type="primary" :underline="false" @click="openUpdateDialog(2)">修改&nbsp</el-link>
            </span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">

          <div class="table-row">
            <span class="table-cell" style="width: 120px; font-weight: bold;">安全邮箱</span>
            <span class="table-cell" style="width: 780px; color: #666;">用于接收消息、验证身份（如找回密码、变更安全设置等）</span>
            <span class="table-cell" style="width: 250px;">{{customer.email}}</span>
            <span class="table-cell" style="width: 70px;">
              <el-link icon="el-icon-edit" type="primary" :underline="false" @click="openUpdateDialog(3)">修改&nbsp</el-link>
            </span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">
        </div>
      </div>

    </section>

    <el-dialog :title="title" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="640px">
      <el-form v-if="updateType==1" ref="passwordForm" :model="passwordForm" :rules="passwordRules">
        <el-form-item label="原密码" prop="originPassword" :label-width="formLabelWidth">
          <el-input v-model="passwordForm.originPassword" type="password"
                    show-password
                    placeholder="请填写原登录密码"
                    style="width: 420px">
          </el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="password" :label-width="formLabelWidth">
          <el-input v-model="passwordForm.password" type="password"
                    show-password
                    placeholder="请填写新的登录密码"
                    style="width: 420px"></el-input>
        </el-form-item>

        <el-form-item label="确认密码" prop="confirmPassword" :label-width="formLabelWidth">
          <el-input v-model="passwordForm.confirmPassword" type="password"
                    show-password
                    placeholder="请填写确认密码"
                    style="width: 420px"></el-input>
        </el-form-item>
      </el-form>

      <el-form v-if="updateType==2" ref="phoneForm" :model="phoneForm" :rules="phoneRules">
        <el-form-item label="登录密码" prop="password" :label-width="formLabelWidth">
          <el-input v-model="phoneForm.password" type="password"
                    show-password
                    placeholder="请填写登录密码"
                    style="width: 420px">
          </el-input>
        </el-form-item>

        <el-form-item label="手机号码" prop="phone" :label-width="formLabelWidth">
          <el-input v-model="phoneForm.phone" type="text" oninput="value=value.replace(/[^\d]/g,'')"
                    maxlength="11"
                    placeholder="请填写新的登录手机号码"
                    style="width: 420px"></el-input>
        </el-form-item>

        <el-form-item label="验证码" prop="code" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入短信验证码"
            prefix-icon="fas fa-envelope"
            type="text"
            maxlength="6"
            style="width: 240px;"
            v-model="phoneForm.code">
          </el-input>
          <el-button type="danger"
                     :disabled="rightPhone"
                     style="width: 180px;"
                     @click.prevent="getCode">
            {{ computeTime ? `已发送(${computeTime})s` : '获取验证码'}}
          </el-button>
        </el-form-item>
      </el-form>

        <el-form v-if="updateType==3" ref="emailForm" :model="emailForm" :rules="emailRules">
          <el-form-item label="登录密码" prop="password" :label-width="formLabelWidth">
            <el-input v-model="emailForm.password" type="password"
                      show-password
                      placeholder="请填写登录密码"
                      style="width: 420px">
            </el-input>
          </el-form-item>

          <el-form-item label="邮箱地址" prop="email" :label-width="formLabelWidth">
            <el-input v-model="emailForm.email" type="text"
                      placeholder="请填写新的邮箱地址"
                      style="width: 420px"></el-input>

          </el-form-item>

          <el-form-item label="验证码" prop="code" :label-width="formLabelWidth">
            <el-input
              placeholder="请输入邮箱验证码"
              prefix-icon="fas fa-envelope"
              type="text"
              maxlength="6"
              style="width: 240px;"
              v-model="emailForm.code">
            </el-input>
            <el-button type="danger"
                       :disabled="rightEmail"
                       style="width: 180px;"
                       @click.prevent="getEmailCode">
              {{ computeTime ? `已发送(${computeTime})s` : '获取验证码'}}
            </el-button>
          </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdate">确 定</el-button>
      </div>
    </el-dialog>

  </main>
</template>

<style>
.el-table .success-cell {
  background: #F0F9EB;
  font-weight: bold;
}
</style>

<script>
import {
  checkPhone,
  checkEmail
} from '@/common/utils.js'
import {
  reqCustomerInfo,
  reqUpdatePassword,
  reqUpdateLoginPhone,
  reqUpdateEmail,
  reqSendCode,
  reqCheckCode,
  reqSendEmailCode
} from '@/api'

export default {
  name: 'AccountSecurity',


  data() {
    // 校验确认密码
    const checkConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请填写确认密码'))
      }
      if (value.trim().length < 8) {
        return callback(new Error('密码长度不少于8位'))
      }
      if (value.trim() != this.passwordForm.password.trim()) {
        return callback(new Error('确认密码与密码不一致'))
      }
      callback()
    }

    return {
      customer: {},
      loading: true,
      dialogFormVisible: false,

      title: '信息修改',
      updateType: 1, // 1-修改密码 2-修改登录手机 3-修改邮箱

      computeTime: 0,

      passwordForm: {
        originPassword: '', // 原登录密码
        password: '', // 密码
        confirmPassword: '' // 确认密码
      },
      passwordRules: {
        originPassword: [
          { required: true, message: '请填写原密码', trigger: 'blur' }
        ],
        password: [
          // { required: true, message: '请填写新密码', trigger: 'blur' }
          { required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/, message: '密码格式不符合要求', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: checkConfirmPassword, trigger: 'blur' }
        ]
      },

      phoneForm: {
        password: '', // 密码
        phone: '', // 手机号码
        code: '', // 验证码
        newPhone: '' // 新手机号码
      },
      phoneRules: {
        password: [
          { required: true, message: '请填写登录密码', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        code: [
          { required: true, pattern: /^\d{6}$/, message: '请填写6位验证码', trigger: 'blur' }
        ],
      },

      emailForm: {
        password: '', // 密码
        email: '', // 邮箱
        code: '', // 验证码
        newEmail: ''
      },
      emailRules: {
        password: [
          { required: true, message: '请填写登录密码', trigger: 'blur' }
        ],
        email: [
          { required: true, validator: checkEmail, trigger: 'blur' }
        ],
        code: [
          { required: true, pattern: /^\d{6}$/, message: '请填写6位验证码', trigger: 'blur' }
        ],
      },

      formLabelWidth: '120px'
    }
  },

  async mounted() {
    const result = await reqCustomerInfo()
    if (result.code === 0) {
      this.customer = result.data
    }
  },

  methods: {
    // 获取短信验证码
    async getCode () {
      if (this.customer.loginPhone === this.phoneForm.phone) {
        this.$message.error('手机号码没有变化，无需更新')
        return
      }

      // computeTime等于0的时候才执行
      if (!this.computeTime) {
        this.computeTime = 60
        this.intervalId = setInterval(() => {
          this.computeTime--
          if (this.computeTime <= 0) {
            clearInterval(this.intervalId)
          }
        }, 1000)


        // 发送ajax请求
        const result = await reqSendCode(this.phoneForm.phone)
        if (result.code === 1) {
          this.$alert(`${ result.message }`, '错误', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          if (this.computeTime) {
            this.computeTime = 0
            clearInterval(this.intervalId)
          }
        } else {
          this.phoneForm.newPhone = this.phoneForm.phone
        }
      }
    },

    // 获取邮箱验证码
    async getEmailCode () {
      if (this.customer.email === this.emailForm.email) {
        this.$message.error('邮箱地址没有变化，无需更新')
        return
      }

      // computeTime等于0的时候才执行
      if (!this.computeTime) {
        this.computeTime = 60
        this.intervalId = setInterval(() => {
          this.computeTime--
          if (this.computeTime <= 0) {
            clearInterval(this.intervalId)
          }
        }, 1000)

        // 发送ajax请求
        const result = await reqSendEmailCode(this.emailForm.email)
        if (result.code === 1) {
          this.$message.error('验证码发送失败 ' + result.message)

          if (this.computeTime) {
            this.computeTime = 0
            clearInterval(this.intervalId)
          }
        } else {
          this.emailForm.newEmail = this.emailForm.email
        }
      }
    },

    openUpdateDialog (updateType) {
      if (updateType === 1) {
        this.title = '修改密码'
      } else if (updateType === 2) {
        this.title = '修改安全手机号'
      } else if (updateType === 3) {
        this.title = '修改安全邮箱'
      }

      this.updateType = updateType
      this.dialogFormVisible = true
    },

    async submitUpdate () {
      if (this.updateType === 1) {
        this.$refs.passwordForm.validate(async (valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '提交中',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            const result = await reqUpdatePassword(this.passwordForm.originPassword, this.passwordForm.password)
            loading.close()
            await this.$alert(`${ result.message }`, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                if (result.code === 0) {
                  this.dialogFormVisible = false
                  this.$refs.passwordForm.resetFields()
                }
              }
            })

          } else {
            await this.$alert('输入信息不正确，请完善后再提交！', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
            return false
          }
        })
      } else if (this.updateType === 2) { // 更新手机号码
        this.$refs.phoneForm.validate(async (valid) => {
          if (valid) {
            if (this.phoneForm.newPhone != this.phoneForm.phone) {
              this.$alert('变更的手机号码有变化，请重新获取验证码', '错误', {
                confirmButtonText: '确定',
                callback: action => {
                }
              })
              if (this.computeTime) {
                this.computeTime = 0
                clearInterval(this.intervalId)
              }
              return
            }

            // 发送ajax请求
            const result2 = await reqCheckCode(this.phoneForm.phone, this.phoneForm.code)
            if (result2.code === 1) {
              this.$alert(`${ result2.message }`, '错误', {
                confirmButtonText: '确定',
                callback: action => {
                }
              })
              if (this.computeTime) {
                this.computeTime = 0
                clearInterval(this.intervalId)
              }
              return
            }

            const loading = this.$loading({
              lock: true,
              text: '提交中',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            const result = await reqUpdateLoginPhone(this.phoneForm.password, this.phoneForm.phone)
            loading.close()
            await this.$alert(`${ result.message }`, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                if (result.code === 0) {
                  this.dialogFormVisible = false
                  this.customer.loginPhone = this.phoneForm.phone
                  this.$refs.phoneForm.resetFields()
                }
              }
            })
          } else {
            await this.$alert('输入信息不正确，请完善后再提交！', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
            return false
          }
        })
      } else if (this.updateType === 3) {
        this.$refs.emailForm.validate(async (valid) => {
          if (valid) {
            if (this.emailForm.newEmail != this.emailForm.email) {
              this.$alert('变更的邮箱地址有变化，请重新获取验证码', '错误', {
                confirmButtonText: '确定',
                callback: action => {
                }
              })
              if (this.computeTime) {
                this.computeTime = 0
                clearInterval(this.intervalId)
              }
              return
            }

            const loading = this.$loading({
              lock: true,
              text: '提交中',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            const result = await reqUpdateEmail(this.emailForm.password, this.emailForm.email, this.emailForm.code)
            loading.close()
            await this.$alert(`${ result.message }`, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                if (result.code === 0) {
                  this.dialogFormVisible = false
                  this.customer.email = this.emailForm.email
                  this.$refs.emailForm.resetFields()
                }
              }
            })
          } else {
            await this.$alert('输入信息不正确，请完善后再提交！', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
            return false
          }
        })
      }
    },

    isRightPhone () {
      return /^1[2|3|4|5|6|7|8|9][0-9]{9}$/.test(this.phoneForm.phone)
    },
  },

  computed: {
    rightPhone () {
      return !(/^1[2|3|4|5|6|7|8|9][0-9]{9}$/.test(this.phoneForm.phone))
    },
    rightEmail () {
      const mailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u
      return !(mailReg.test(this.emailForm.email))
    }
  }

}
</script>

<style scoped>

main {
  display: flex;
  flex-direction: column;
}

.content_wrapper {
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/AccountSecurity/AccountSecurity.vue